/** Registro operazioni: chi, cosa, quando. Mai i valori, solo i nomi dei campi cambiati. */
import { Select, Table } from "antd";
import { useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import type { RegistroRigaDto } from "@qa/shared";
import { api } from "../../api/client";
import { fmtDataOra } from "../../lib/format";
import { messaggioErrore } from "../../i18n/errori";
import { PageHead } from "../../components/ui";

const ENTITA = ["segnalazione", "nc", "claim", "proposta", "voce_lista", "utente", "richiesta_accesso", "import"];

export default function RegistroPage() {
  const { t } = useTranslation();
  const [entita, setEntita] = useState<string | undefined>();
  const q = useQuery({ queryKey: ["registro", entita], queryFn: () => api.get<RegistroRigaDto[]>("/admin/registro", { limit: 500, entita }), placeholderData: keepPreviousData });
  return (
    <>
      <PageHead crumbs={[{ label: t("portale.nome"), to: "/" }, { label: t("menu.gruppoAdmin") }, { label: t("menu.registro") }]} title={t("admin.registro.titolo")} sub={t("admin.registro.sottotitolo")} />
      <Select allowClear placeholder={t("admin.registro.tutte")} value={entita} onChange={setEntita} style={{ width: 220, marginBottom: 14 }} options={ENTITA.map((e) => ({ value: e, label: e }))} />
      <Table<RegistroRigaDto>
        rowKey="id"
        size="middle"
        loading={q.isFetching}
        dataSource={q.data ?? []}
        pagination={{ pageSize: 100, hideOnSinglePage: true, showSizeChanger: false }}
        scroll={{ x: 800 }}
        locale={{ emptyText: q.isError ? messaggioErrore(q.error) : t("admin.registro.vuoto") }}
        columns={[
          { title: t("admin.registro.quando"), key: "at", width: 160, render: (_, r) => <span className="num">{fmtDataOra(r.at)}</span> },
          { title: t("admin.registro.chi"), dataIndex: "utente", width: 180 },
          { title: t("admin.registro.cosa"), dataIndex: "azione", width: 120 },
          { title: t("admin.registro.dove"), key: "e", width: 200, render: (_, r) => <span className="mono">{r.entita}{r.entitaId ? ` · ${r.entitaId.slice(0, 8)}` : ""}</span> },
          { title: t("admin.registro.dettaglio"), key: "d", render: (_, r) => r.dettaglio ?? "—" },
        ]}
      />
    </>
  );
}
